import React from 'react';

import { BrowserRouter } from 'react-router-dom';
import {I18nextProvider} from "react-i18next";
import { Provider } from 'react-redux';
import i18next from "i18next";

import store from './store/store';
import Router from './routes/router';
import common_de from "./translations/de/common.json";
import common_en from "./translations/en/common.json";

import "./styles/app.scss";


i18next.init({
  interpolation: { escapeValue: false },  // React already does escaping
  lng: 'en',                              // language to use
  resources: {
      en: {
          common: common_en               // 'common' is our custom namespace
      },
      de: {
          common: common_de
      },
  },
});


function App() {

  return (
    <div className="app">
      <Provider store={store}>
        <BrowserRouter>
            <I18nextProvider i18n={i18next}>
              <Router/>
            </I18nextProvider>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
